import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../authContext'; // Adjust the path as per your directory structure

const Admin = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/'); // Redirect to the homepage after logout
        } catch (error) {
            console.error('Failed to logout:', error);
        }
    };

    return (
        <div>
            <h1>Admin Panel</h1>
            <p>Welcome to the Admin Panel! You are now logged in.</p>
            <button onClick={handleLogout}>Logout</button>
        </div>
    );
};

export default Admin;
